
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-8d16377e&scoped=true!stylus-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./bookSwipe.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./bookSwipe.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8d16377e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bookSwipe.vue"),
  /* scopeId */
  "data-v-8d16377e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/book/bookSwipe.vue
// module id = 44
// module chunks = 1